import { render, staticRenderFns } from "./ProcessoExistente.vue?vue&type=template&id=259afdb2&"
import script from "./ProcessoExistente.vue?vue&type=script&lang=js&"
export * from "./ProcessoExistente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports